export default "__VITE_ASSET__f347c376__"